module.exports = __webpack_public_path__ + "img/signin.9b3b7c10.png";